import React, { useState, useRef, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import { FiArrowRight, FiX, FiPlay, FiVolume2, FiVolumeX, FiMaximize2, FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { useInView } from "../components/useInView";
import "./ProjectVideos.css";

/* ════════════════════════════════════════════════════════════
   HERO BACKGROUND — reuse portfolio hero
   ════════════════════════════════════════════════════════════ */
import heroBg from "../assets/images/portfolio/ppt_media_image18.jpeg";

/* ════════════════════════════════════════════════════════════
   PARTNER LOGOS
   ════════════════════════════════════════════════════════════ */
import partner_1  from "../assets/images/partners/partner_01.jpg";
import partner_2  from "../assets/images/partners/partner_02.jpg";
import partner_3  from "../assets/images/partners/partner_03.jpg";
import partner_4  from "../assets/images/partners/partner_04.jpg";
import partner_5  from "../assets/images/partners/partner_05.jpg";
import partner_6  from "../assets/images/partners/partner_06.jpg";
import partner_8  from "../assets/images/partners/partner_08.jpg";
import partner_9  from "../assets/images/partners/partner_09.jpg";
import partner_10 from "../assets/images/partners/partner_10.jpg";
import partner_11 from "../assets/images/partners/partner_11.jpg";
import partner_12 from "../assets/images/partners/partner_12.jpg";
import partner_13 from "../assets/images/partners/partner_13.jpg";
import partner_14 from "../assets/images/partners/partner_14.jpg";
import partner_15 from "../assets/images/partners/partner_15.png";
import partner_16 from "../assets/images/partners/partner_16.jpg";
import partner_17 from "../assets/images/partners/partner_17.jpg";

const partnerLogos = [
  partner_1, partner_2, partner_3, partner_4, partner_5,
  partner_6, partner_8, partner_9, partner_10,
  partner_11, partner_12, partner_13, partner_14, partner_15,
  partner_16, partner_17,
];

/* ════════════════════════════════════════════════════════════
   VIDEO IMPORTS — Landscape (8)
   ════════════════════════════════════════════════════════════ */
import lv1  from "../assets/images/videos/landscape_video1.mp4";
import lv2  from "../assets/images/videos/landscape_video2.mp4";
import lv3  from "../assets/images/videos/landscape_video3.mp4";
import lv4  from "../assets/images/videos/landscape_video4.mp4";
import lv5  from "../assets/images/videos/landscape_video5.mp4";
import lv6  from "../assets/images/videos/landscape_video6.mp4";
import lv7  from "../assets/images/videos/landscape_video7.mp4";
import lv8  from "../assets/images/videos/landscape_video8.mp4";

/* ════════════════════════════════════════════════════════════
   VIDEO IMPORTS — Portrait (20)
   ════════════════════════════════════════════════════════════ */
import pv1  from "../assets/images/videos/portrait_video1.mp4";
import pv2  from "../assets/images/videos/portrait_video2.mp4";
import pv3  from "../assets/images/videos/portrait_video3.mp4";
import pv4  from "../assets/images/videos/portrait_video4.mp4";
import pv5  from "../assets/images/videos/portrait_video5.mp4";
import pv6  from "../assets/images/videos/portrait_video6.mp4";
import pv7  from "../assets/images/videos/portrait_video7.mp4";
import pv8  from "../assets/images/videos/portrait_video8.mp4";
import pv9  from "../assets/images/videos/portrait_video9.mp4";
import pv10 from "../assets/images/videos/portrait_video10.mp4";
import pv11 from "../assets/images/videos/portrait_video11.mp4";
import pv12 from "../assets/images/videos/portrait_video12.mp4";
import pv13 from "../assets/images/videos/portrait_video13.mp4";
import pv14 from "../assets/images/videos/portrait_video14.mp4";
import pv15 from "../assets/images/videos/portrait_video15.mp4";
import pv16 from "../assets/images/videos/portrait_video16.mp4";
import pv17 from "../assets/images/videos/portrait_video17.mp4";
import pv18 from "../assets/images/videos/portrait_video18.mp4";
import pv19 from "../assets/images/videos/portrait_video19.mp4";
import pv20 from "../assets/images/videos/portrait_video20.mp4";

/* ════════════════════════════════════════════════════════════
   VIDEO IMPORTS — Square (15)
   ════════════════════════════════════════════════════════════ */
import sv1  from "../assets/images/videos/square_video1.mp4";
import sv3  from "../assets/images/videos/square_video3.mp4";
import sv4  from "../assets/images/videos/square_video4.mp4";
import sv5  from "../assets/images/videos/square_video5.mp4";
import sv6  from "../assets/images/videos/square_video6.mp4";
import sv7  from "../assets/images/videos/square_video7.mp4";
import sv8  from "../assets/images/videos/square_video8.mp4";
import sv9  from "../assets/images/videos/square_video9.mp4";
import sv10 from "../assets/images/videos/square_video10.mp4";
import sv11 from "../assets/images/videos/square_video11.mp4";
import sv12 from "../assets/images/videos/square_video12.mp4";
import sv13 from "../assets/images/videos/square_video13.mp4";
import sv14 from "../assets/images/videos/square_video14.mp4";
import sv15 from "../assets/images/videos/square_video15.mp4";

/* ════════════════════════════════════════════════════════════
   VIDEO DATA GROUPS
   ════════════════════════════════════════════════════════════ */
const landscapeVideos = [
  { id: "l1",  src: lv1,  title: "Landscape Project 1"  },
  { id: "l2",  src: lv2,  title: "Landscape Project 2"  },
  { id: "l3",  src: lv3,  title: "Landscape Project 3"  },
  { id: "l4",  src: lv4,  title: "Landscape Project 4"  },
  { id: "l5",  src: lv5,  title: "Landscape Project 5"  },
  { id: "l6",  src: lv6,  title: "Landscape Project 6"  },
  { id: "l7",  src: lv7,  title: "Landscape Project 7"  },
  { id: "l8",  src: lv8,  title: "Landscape Project 8"  },
];

const portraitVideos = [
  { id: "p1",  src: pv1,  title: "Site Operations 1"    },
  { id: "p2",  src: pv2,  title: "Site Operations 2"    },
  { id: "p3",  src: pv3,  title: "Site Operations 3"    },
  { id: "p4",  src: pv4,  title: "Site Operations 4"    },
  { id: "p5",  src: pv5,  title: "Site Operations 5"    },
  { id: "p6",  src: pv6,  title: "Site Operations 6"    },
  { id: "p7",  src: pv7,  title: "Site Operations 7"    },
  { id: "p8",  src: pv8,  title: "Site Operations 8"    },
  { id: "p9",  src: pv9,  title: "Site Operations 9"    },
  { id: "p10", src: pv10, title: "Site Operations 10"   },
  { id: "p11", src: pv11, title: "Site Operations 11"   },
  { id: "p12", src: pv12, title: "Site Operations 12"   },
  { id: "p13", src: pv13, title: "Site Operations 13"   },
  { id: "p14", src: pv14, title: "Site Operations 14"   },
  { id: "p15", src: pv15, title: "Site Operations 15"   },
  { id: "p16", src: pv16, title: "Site Operations 16"   },
  { id: "p17", src: pv17, title: "Site Operations 17"   },
  { id: "p18", src: pv18, title: "Site Operations 18"   },
  { id: "p19", src: pv19, title: "Site Operations 19"   },
  { id: "p20", src: pv20, title: "Site Operations 20"   },
];

const squareVideos = [
  { id: "s1",  src: sv1,  title: "Construction Clip 1"  },
  { id: "s3",  src: sv3,  title: "Construction Clip 3"  },
  { id: "s4",  src: sv4,  title: "Construction Clip 4"  },
  { id: "s5",  src: sv5,  title: "Construction Clip 5"  },
  { id: "s6",  src: sv6,  title: "Construction Clip 6"  },
  { id: "s7",  src: sv7,  title: "Construction Clip 7"  },
  { id: "s8",  src: sv8,  title: "Construction Clip 8"  },
  { id: "s9",  src: sv9,  title: "Construction Clip 9"  },
  { id: "s10", src: sv10, title: "Construction Clip 10" },
  { id: "s11", src: sv11, title: "Construction Clip 11" },
  { id: "s12", src: sv12, title: "Construction Clip 12" },
  { id: "s13", src: sv13, title: "Construction Clip 13" },
  { id: "s14", src: sv14, title: "Construction Clip 14" },
  { id: "s15", src: sv15, title: "Construction Clip 15" },
];

const ALL_GROUPS = [
  { key: "landscape", label: "Landscape",  videos: landscapeVideos, count: landscapeVideos.length },
  { key: "portrait",  label: "Portrait",   videos: portraitVideos,  count: portraitVideos.length  },
  { key: "square",    label: "Square",     videos: squareVideos,    count: squareVideos.length    },
];

/* ════════════════════════════════════════════════════════════
   VIDEO LIGHTBOX
   ════════════════════════════════════════════════════════════ */
function VideoLightbox({ video, allVideos, onClose }) {
  const [muted, setMuted] = useState(false);
  const [idx, setIdx] = useState(() => allVideos.findIndex(v => v.id === video.id));
  const videoRef = useRef(null);

  const current = allVideos[idx];

  const navigate = useCallback((dir) => {
    const next = idx + dir;
    if (next < 0 || next >= allVideos.length) return;
    setIdx(next);
    if (videoRef.current) { videoRef.current.pause(); videoRef.current.load(); }
  }, [idx, allVideos.length]);

  useEffect(() => {
    const handler = (e) => {
      if (e.key === "Escape")     onClose();
      if (e.key === "ArrowLeft")  navigate(-1);
      if (e.key === "ArrowRight") navigate(1);
      if (e.key === "m")          setMuted(m => !m);
    };
    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [navigate, onClose]);

  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => { document.body.style.overflow = ""; };
  }, []);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
      videoRef.current.play().catch(() => {});
    }
  }, [idx]);

  return (
    <div className="vl-lightbox" role="dialog" aria-modal="true">
      <div className="vl-lightbox__backdrop" onClick={onClose} />
      <div className="vl-lightbox__panel">
        <div className="vl-lightbox__header">
          <div className="vl-lightbox__title-wrap">
            <span className="vl-lightbox__title">{current.title}</span>
            <span className="vl-lightbox__counter">{idx + 1} / {allVideos.length}</span>
          </div>
          <div className="vl-lightbox__controls">
            <button className="vl-lightbox__ctrl-btn" onClick={() => setMuted(m => !m)} aria-label="Toggle mute">
              {muted ? <FiVolumeX size={16} /> : <FiVolume2 size={16} />}
            </button>
            <button className="vl-lightbox__ctrl-btn" onClick={onClose} aria-label="Close">
              <FiX size={18} />
            </button>
          </div>
        </div>
        <div className="vl-lightbox__stage">
          <video
            ref={videoRef}
            key={current.id}
            className="vl-lightbox__video"
            controls
            autoPlay
            muted={muted}
            playsInline
            onContextMenu={(e) => e.preventDefault()}
          >
            <source src={current.src} type="video/mp4" />
          </video>
          {allVideos.length > 1 && (
            <>
              <button className="vl-lightbox__nav vl-lightbox__nav--prev" onClick={() => navigate(-1)} disabled={idx === 0} aria-label="Previous video">
                <FiChevronLeft size={22} />
              </button>
              <button className="vl-lightbox__nav vl-lightbox__nav--next" onClick={() => navigate(1)} disabled={idx === allVideos.length - 1} aria-label="Next video">
                <FiChevronRight size={22} />
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

/* ════════════════════════════════════════════════════════════
   VIDEO CARD
   ════════════════════════════════════════════════════════════ */
function VideoCard({ video, aspect, delay, onOpen }) {
  const [ref, inView] = useInView();
  const previewRef = useRef(null);
  const [hovered, setHovered] = useState(false);

  const handleMouseEnter = () => {
    setHovered(true);
    if (previewRef.current) {
      previewRef.current.currentTime = 0;
      previewRef.current.play().catch(() => {});
    }
  };
  const handleMouseLeave = () => {
    setHovered(false);
    if (previewRef.current) {
      previewRef.current.pause();
      previewRef.current.currentTime = 0;
    }
  };

  return (
    <div
      ref={ref}
      className={`vc-card vc-card--${aspect} fade-in${inView ? " visible" : ""}`}
      style={{ transitionDelay: `${delay}s` }}
      onClick={() => onOpen(video)}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onOpen(video)}
      aria-label={`Play ${video.title}`}
      onContextMenu={(e) => e.preventDefault()}
    >
      <div className="vc-card__media">
        {/* Silent preview on hover */}
        <video
          ref={previewRef}
          className={`vc-card__preview${hovered ? " vc-card__preview--active" : ""}`}
          src={video.src}
          muted
          loop
          playsInline
          preload="metadata"
          onContextMenu={(e) => e.preventDefault()}
        />
        <div className="vc-card__overlay" />
        <div className={`vc-card__play${hovered ? " vc-card__play--hovered" : ""}`}>
          <FiPlay size={aspect === "portrait" ? 20 : 24} />
        </div>
        <div className="vc-card__aspect-badge">{aspect.toUpperCase()}</div>
      </div>
      <div className="vc-card__body">
        <h3 className="vc-card__title">{video.title}</h3>
        <button className="vc-card__link">
          Play Video
          <span className="vc-card__arrow"><FiArrowRight size={13} /></span>
        </button>
      </div>
    </div>
  );
}

/* ════════════════════════════════════════════════════════════
   VIDEO GROUP SECTION
   ════════════════════════════════════════════════════════════ */
function VideoGroup({ group, onOpen }) {
  const [ref, inView] = useInView();

  return (
    <section className={`vg-section vg-section--${group.key}`} id={group.key}>
      <div className="container">
        <div className={`vg-section__head fade-in${inView ? " visible" : ""}`} ref={ref}>
          <div className="vg-section__tag-row">
            <div className="vg-section__tag">PROJECT VIDEOS</div>
            <div className="vg-section__count-pill">{group.count} Videos</div>
          </div>
          <h2 className="vg-section__title">
            {group.label} <span>Videos</span>
          </h2>
          <div className="vg-section__bar" />
        </div>

        <div className={`vg-grid vg-grid--${group.key}`}>
          {group.videos.map((video, i) => (
            <VideoCard
              key={video.id}
              video={video}
              aspect={group.key}
              delay={Math.min(i * 0.05, 0.3)}
              onOpen={(v) => onOpen(v, group.videos)}
            />
          ))}
        </div>
      </div>
    </section>
  );
}

/* ════════════════════════════════════════════════════════════
   PAGE
   ════════════════════════════════════════════════════════════ */
export default function ProjectVideos() {
  const [heroRef, heroInView] = useInView();
  const [lightbox, setLightbox] = useState(null); // { video, allVideos }

  const openLightbox = (video, allVideos) => setLightbox({ video, allVideos });
  const closeLightbox = () => setLightbox(null);

  useEffect(() => {
    const handler = (e) => e.preventDefault();
    document.addEventListener("contextmenu", handler);
    return () => document.removeEventListener("contextmenu", handler);
  }, []);

  const totalVideos = landscapeVideos.length + portraitVideos.length + squareVideos.length;

  return (
    <main className="pv-page">

      {/* ══════ 1. HERO ══════ */}
      <section className="pv-hero" style={{ backgroundImage: `url(${heroBg})` }}>
        <div className="pv-hero__overlay" />
        <div className="container pv-hero__body" ref={heroRef}>
          <div className={`pv-hero__label fade-in${heroInView ? " visible" : ""}`}>
            PROJECT VIDEOS
          </div>
          <h1
            className={`pv-hero__title fade-in${heroInView ? " visible" : ""}`}
            style={{ transitionDelay: "0.1s" }}
          >
            OUR WORK <br />IN MOTION
          </h1>
          <p
            className={`pv-hero__sub fade-in${heroInView ? " visible" : ""}`}
            style={{ transitionDelay: "0.2s" }}
          >
            {totalVideos} videos across landscape, portrait and square formats — real sites, real results.
          </p>

          {/* Group jump pills */}
          <div
            className={`pv-hero__pills fade-in${heroInView ? " visible" : ""}`}
            style={{ transitionDelay: "0.3s" }}
          >
            {ALL_GROUPS.map((g) => (
              <a key={g.key} href={`#${g.key}`} className="pv-hero__pill">
                {g.label}
                <span className="pv-hero__pill-count">{g.count}</span>
              </a>
            ))}
          </div>
        </div>

        <div className="pv-hero__crumb">
          <Link to="/">Home</Link>
          <FiArrowRight size={13} />
          <Link to="/portfolio">Portfolio</Link>
          <FiArrowRight size={13} />
          <span>Project Videos</span>
        </div>
      </section>

      {/* ══════ HAZARD STRIPE ══════ */}
      <div className="pv-stripe" aria-hidden="true" />

      {/* ══════ 2. VIDEO GROUPS ══════ */}
      {ALL_GROUPS.map((group) => (
        <VideoGroup key={group.key} group={group} onOpen={openLightbox} />
      ))}

      {/* ══════ 3. HAZARD STRIPE ══════ */}
      <div className="pv-stripe" aria-hidden="true" />

      {/* ══════ 4. PARTNER LOGOS MARQUEE ══════ */}
      <section className="pv-partners">
        <div className="pv-partners__label-bar">
          <div className="container">
            <span className="pv-partners__heading">PROJECT REFERENCES &amp; CLIENTS</span>
          </div>
        </div>
        <div className="pv-partners__marquee">
          <div className="pv-partners__track">
            {[...partnerLogos, ...partnerLogos].map((src, i) => (
              <div key={i} className="pv-partners__logo">
                <img
                  src={src}
                  alt={`Partner ${(i % partnerLogos.length) + 1}`}
                  loading="lazy"
                  draggable="false"
                  onDragStart={(e) => e.preventDefault()}
                  onContextMenu={(e) => e.preventDefault()}
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ══════ LIGHTBOX ══════ */}
      {lightbox && (
        <VideoLightbox
          video={lightbox.video}
          allVideos={lightbox.allVideos}
          onClose={closeLightbox}
        />
      )}

    </main>
  );
}